import React, { useState } from 'react';
import { useSchool } from '../context/SchoolContext';
import { Search, ArrowUpRight, FileText, Pencil } from 'lucide-react';
import AddExpenseModal from '../components/AddExpenseModal';
import ImportModal from '../components/ImportModal';
import './Expenses.css';

const Expenses = () => {
    const { financials, importExpenses } = useSchool();
    const [isPayoutModalOpen, setIsPayoutModalOpen] = useState(false);
    const [isImportModalOpen, setIsImportModalOpen] = useState(false);
    const [expenseToEdit, setExpenseToEdit] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    const expenseTemplateHeaders = ['Date', 'Category', 'Amount', 'Payment Method', 'Description'];
    const expenseSampleRow = ['2026-02-01', 'Fuel', '50', 'Cash', 'Fuel for school vehicle'];

    const handleEdit = (expense) => {
        setExpenseToEdit(expense);
        setIsPayoutModalOpen(true);
    };

    const handleAdd = () => {
        setExpenseToEdit(null);
        setIsPayoutModalOpen(true);
    };

    const filteredExpenses = (financials.expenses || []).filter(e =>
        e.category?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        e.description?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="page-container">
            <div className="page-header">
                <div>
                    <h2 className="page-title">Expense Management</h2>
                    <p className="page-subtitle">Track payments out and operational costs</p>
                </div>
                <div className="header-actions flex gap-2">
                    <button className="btn btn-secondary flex items-center gap-2" onClick={() => setIsImportModalOpen(true)}>
                        <FileText size={18} /> Import CSV
                    </button>
                    <button className="btn btn-primary flex items-center gap-2" onClick={handleAdd}>
                        <ArrowUpRight size={18} /> Record Payout
                    </button>
                </div>
            </div>

            <div className="filters-bar">
                <div className="search-input-wrapper">
                    <Search size={18} className="search-icon" />
                    <input
                        type="text"
                        placeholder="Search expenses or categories..."
                        className="search-input"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            <div className="card table-container">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Category</th>
                            <th>Description</th>
                            <th>Method</th>
                            <th>Amount</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredExpenses.length === 0 ? (
                            <tr><td colSpan="5" className="text-center py-8 text-secondary">No expenses recorded.</td></tr>
                        ) : (
                            filteredExpenses.map(exp => (
                                <tr key={exp.id || Math.random()}>
                                    <td>{exp.expense_date || exp.date ? new Date(exp.expense_date || exp.date).toLocaleString() : 'N/A'}</td>
                                    <td><span className="status-badge grey">{exp.category}</span></td>
                                    <td>{exp.description || '-'}</td>
                                    <td>{exp.method}</td>
                                    <td className="font-bold text-red">-${parseFloat(exp.amount).toFixed(2)}</td>
                                    <td>
                                        <button className="btn-link text-gold" onClick={() => handleEdit(exp)} title="Edit">
                                            <Pencil size={16} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <AddExpenseModal
                isOpen={isPayoutModalOpen}
                onClose={() => setIsPayoutModalOpen(false)}
                expenseToEdit={expenseToEdit}
            />

            <ImportModal
                isOpen={isImportModalOpen}
                onClose={() => setIsImportModalOpen(false)}
                onImport={importExpenses}
                title="Import Expenses"
                templateHeaders={expenseTemplateHeaders}
                sampleRow={expenseSampleRow}
            />
        </div>
    );
};

export default Expenses;
